import { render, staticRenderFns } from "./AboutOneSupportOnlyDiv.vue?vue&type=template&id=0de26a96"
import script from "./AboutOneSupportOnlyDiv.vue?vue&type=script&lang=js"
export * from "./AboutOneSupportOnlyDiv.vue?vue&type=script&lang=js"
import style0 from "./AboutOneSupportOnlyDiv.vue?vue&type=style&index=0&id=0de26a96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports